import React from 'react';
import '../styles/pages/dataSets.scss';
import { useNavigate } from "react-router-dom";
import { DateFormatter } from '../utils/DateFormatter.js';
import Lock from "../assets/icons/lock"

const SamplesCard = props => {
    const {content} = props;
    let navigate = useNavigate(); 

    console.log('content', content);

    const navigateToSamples = (dataset_name, dataset_id) =>{ 
        // const path = "manage_sample/new_sample/upload-csv" ; 
        const path = "dataset_details" ; 
        navigate(path,{
            state:{
                id:dataset_id,
                name:dataset_name
            }
        })
      }

    return (
        <>
            {content?.map((data) => {
                return (
                    <div className="card content col" /*onClick={()=> navigateToSamples(data?.name, data?.id)}*/>
                        <div className="cardHeader">
                            <div style={{ fontWeight: "500", fontSize: "12px" }}>{data?.name}</div>
                            <Lock />
                        </div>
                        <div className="row">
                            <div className="col">
                                <div style={{fontSize: "10px" }}>No. of files</div>
                                <div>{data?.files ? data?.files.length : 0}</div>
                            </div>
                            {/* <div className="col">
                                <div style={{fontSize: "10px" }}>No. of workflows</div>
                                <div>{data?.number_of_workflows ? data?.number_of_workflows : 0}</div>
                            </div> */}
                        </div>
                        <br /><br />
                        <div className="row">
                            <div className="col">
                                <div style={{fontSize: "10px" }}>Created</div>
                            </div>
                            <div className="col">
                                <div style={{fontSize: "10px" }}>{DateFormatter(data?.createdAt)}</div>
                            </div>
                        </div>
                        {/* <div className='row'>
                            <div style={{ color: "#42B0D4" }}>{data?.createdByUsername}</div>
                        </div> */}
                        <div className="row">
                            <div className="col">
                                <div style={{fontSize: "10px" }}>Last Modified</div>
                            </div>
                            <div className="col">
                                <div style={{fontSize: "10px" }}>{DateFormatter(data?.updatedAt)}</div>
                            </div>
                        </div>
                        {/* <div className='row'>
                            <div style={{ color: "#42B0D4" }}>{data?.lastModifiedByUsername}</div>
                        </div> */}
                    </div>
                )
            })}
        </>
    );
};

export default SamplesCard;
